<template>
  <div>
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-dropdown @command="setSeleteFactory">
          <el-button type="default" size="mini">
            {{ $t("action.selectFactory") }}
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="factory of factories"
              :key="factory.id"
              :command="factory"
              >{{ factory.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </vxe-toolbar>
    <vxe-table
      :data="ordersNew"
      :loading="loading"
      class="recordsTable"
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="images" :title="$t('product.images')" width="85">
        <template v-slot="{ row }">
          <thumbnail :images="row.images" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="serialNo"
        :title="$t('text.serialNo')"
        min-width="85"
      >
        <template v-slot="{ row }">
          <small v-if="row.hurry" class="red">
            ({{ $t("order.hurrySimple") }})
          </small>
          {{ row.serialNo }}
          <div class="font10">{{ row.innerSerialNo }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="productNo"
        :title="$t('product.productNo')"
        min-width="120"
      >
        <template v-slot="{ row }">
          {{ row.productNo }}
          <div class="font10">{{ row.color }} {{ row.size }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="quantity"
        :title="$t('text.quantity')"
        min-width="60"
      />
      <vxe-table-column :title="$t('mesOrder.price')" min-width="160">
        <template v-slot="{ row }">
          <el-select
            v-model="row.factoryId"
            :placeholder="$t('rules.select', [$t('menu.factories')])"
            size="small"
            class="mgb5"
          >
            <el-option
              v-for="factory in factories"
              :key="factory.id"
              :label="factory.name"
              :value="factory.id"
            >
            </el-option>
          </el-select>
          <el-input
            v-if="Permit.canActions('globalCostPrice')"
            size="small"
            v-model.trim="row.costPrice"
            :placeholder="$t('mesOrder.price')"
          ></el-input>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="handOverAt"
        :title="$t('text.handOverAt')"
        width="110"
      /> -->
      <vxe-table-column :title="$t('text.handOverAt')" min-width="150">
        <template v-slot="{ row }">
          {{ row.handOverAt }}
          <el-date-picker
            size="small"
            :placeholder="$t('text.handOverAt')"
            v-model="row.mesHandOverAt"
            type="date"
            style="width: 100%"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="remark"
        :title="$t('text.remark')"
        min-width="80"
      >
        <template v-slot="{ row, rowIndex }">
          <div v-if="row.dealSuggest != null" class="red">
            <raw-html-limit-number :content="row.dealSuggest" :number="4" />
          </div>
          <div>
            <i
              slot="reference"
              class="el-icon-edit fl"
              @click="editRemark(row, rowIndex)"
            />
            <raw-html-limit-number
              :content="row.remark"
              :number="6"
              type="richText"
            />
          </div>
          <div>
            <attribute :content="row.specJson" :number="6" />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="action" :title="$t('text.action')" width="55">
        <template v-slot="{ row, rowIndex }">
          <el-button type="text" @click="remove(row, rowIndex)" size="mini">
            {{ $t("text.remove") }}
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="right pd20">
      <span
        v-if="
          Permit.extendModels().includes('mes') &&
          Permit.currentTenant().config.mesSchedule == true
        "
        >以上订单类型是：
        <el-radio-group v-model="type" class="mgr20">
          <el-radio label="bulk">{{ $t("dealOrderTypes.bulk") }}</el-radio>
          <el-radio label="custom">{{ $t("dealOrderTypes.custom") }}</el-radio>
        </el-radio-group></span
      >
      <el-button
        size="small"
        type="primary"
        :loading="submitDoing"
        @click="submit"
      >
        {{ $t("text.submit") }}
      </el-button>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>

    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('text.remark')])"
      :close-on-click-modal="false"
      :visible.sync="editRemarkDF"
      v-if="editRemarkDF"
      width="50%"
    >
      <el-form label-width="80px">
        <tinymce-editor
          ref="editor"
          v-model="editRemarkObj.remark"
          :height="300"
        ></tinymce-editor>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRemarkDoing"
          size="small"
          @click="editRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Util from "@/utils";
import { page } from "@/utils/mixins.js";
import Factory from "@/api/factory.js";
import Order from "@/api/order.js";
import TinymceEditor from "@/components/TinymceEditor";

export default {
  props: {
    orders: Array,
  },
  mixins: [page],
  components: {
    TinymceEditor,
  },
  data() {
    return {
      factories: [],
      ordersNew: [],
      type: "bulk",
      submitDoing: false,
      loading: false,
      //编辑备注
      currentRowIdx: null,
      editRemarkDF: false,
      editRemarkObj: {
        remark: null,
        uuid: null,
      },
      editRemarkDoing: false,
    };
  },
  watch: {
    orders() {
      this.getOrdersNew();
    },
  },
  created() {
    const self = this;
    Factory.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.factories = res.data;
        self.getOrdersNew();
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    //
    editRemark(row, rowIndex) {
      this.editRemarkObj.uuid = row.uuid;
      this.editRemarkObj.remark = row.remark;
      this.currentRowIdx = rowIndex;
      this.editRemarkDoing = false;
      this.editRemarkDF = true;
    },
    editRemarkSubmit() {
      const self = this;
      self.editRemarkDoing = true;
      Order.updateRemark(self.editRemarkObj).then(function (res) {
        self.editRemarkDoing = false;
        self.editRemarkDF = false;
        if (res.status === 200) {
          self.ordersNew[self.currentRowIdx].remark = self.editRemarkObj.remark;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },

    getOrdersNew() {
      const self = this;
      self.loading = true;
      Order.batchPreProcessing(self.orders.map((o) => o.id)).then(function (
        res
      ) {
        if (res.status === 200) {
          self.ordersNew = res.data;
          for (const o of self.ordersNew) {
            Vue.set(o, "factories", self.factories);
            Vue.set(o, "mesHandOverAt", o.handOverAt);
          }
        } else {
          self.sysError();
        }
        self.loading = false;
      });
    },

    setSeleteFactory(factory) {
      for (const r of this.ordersNew) {
        r.factoryId = factory.id;
      }
    },
    submit() {
      const self = this;
      if (self.ordersNew.length === 0) {
        self.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      let data = [];
      for (const o of self.ordersNew) {
        if (
          o.factoryId == null ||
          self.factories.find((f) => f.id == o.factoryId) == null
        ) {
          self.$message({
            message: self.$t("rules.select", [self.$t("menu.factories")]),
            type: "warning",
          });
          return;
        }
        let obj = {
          id: o.id,
          costPrice: o.costPrice,
          factoryId: o.factoryId,
          factoryName: self.factories.find((f) => f.id == o.factoryId).name,
          type: self.type,
          handOverAt:
            o.mesHandOverAt != null ? Util.formatDate(o.mesHandOverAt) : null,
        };
        data.push(obj);
      }
      self.submitDoing = true;
      Order.batchProcessing(data).then(function (res) {
        self.submitDoing = false;
        if (res.status === 200) {
          self.sysResults(res.data, self.$t("prompt.dealSuccess"));
          self.$emit("updateData");
          self.$eventHub.$emit("orderBatchProcessing");
        } else {
          self.sysError();
        }
      });
    },
    close() {
      this.$emit("close");
    },
    remove(row, rowIndex) {
      this.ordersNew.splice(rowIndex, 1);
    },
  },
};
</script>
